import {
  CreateDatasetOperationRequest,
  CreateDatasetRequest,
  CreateNewDatasetVersionRequest,
  DatasetVersionControllerApi,
  DatesetControllerApi,
  UpdateDatasetOperationRequest,
} from './generated'
import { REQUEST_OPTIONS } from './_configs'

export const commonDatasetApiClient = new DatasetVersionControllerApi()
export const datasetApiClient = new DatesetControllerApi()
export const datasetVersionApiClient = new DatasetVersionControllerApi()

export const getDatasets = async () => {
  const response = await commonDatasetApiClient.getDatasetVersionsRaw(REQUEST_OPTIONS)
  const jsonData = await response.value()

  return jsonData
}

export const getDataset = async (datasetId: string) => {
  const response = await datasetApiClient.getDatasetDetailsRaw({ datasetId }, REQUEST_OPTIONS)
  const jsonData = await response.value()

  return jsonData
}

export const patchDataset = async (
  datasetId: string,
  updateDatasetRequest: UpdateDatasetOperationRequest['updateDatasetRequest'],
) => {
  const body: UpdateDatasetOperationRequest = {
    datasetId,
    updateDatasetRequest,
  }
  return datasetApiClient.updateDataset(body, REQUEST_OPTIONS)
}

export const create = async (createDatasetRequest: CreateDatasetRequest) => {
  const body: CreateDatasetOperationRequest = {
    createDatasetRequest,
  }
  return datasetApiClient.createDataset(body, REQUEST_OPTIONS)
}

export const cloneDatasetVersion = async (datasetId: string, versionLabel: string) => {
  const body: CreateNewDatasetVersionRequest = {
    datasetId,
    versionLabel,
  }
  return datasetVersionApiClient.createNewDatasetVersion(body, REQUEST_OPTIONS)
}
